import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import AccountDetailButton from './AccountDetailButton';
import { SectionWrapper } from '../SectionWrapper';

const Balance = ({ availableBalance, accountDetails, addFundModalHref }) => {
  const linkPressedTracker = useLinkPressedCallback({
    elementName: 'add_funds_banking_widget',
    elementText: 'add_funds_banking_widget',
    appPageName: 'active_banking_dashboard',
    destination: addFundModalHref
  });

  const handleClickAddFunds = () => {
    linkPressedTracker();
  };

  return (
    <SectionWrapper
      gap="8px"
      height="100%"
      justifyContent="space-between"
    >
      <Stack gap="8px">
        <Text
          size="lg"
          weight="medium"
        >
          Available balance
        </Text>
        {addFundModalHref ? (
          <Button
            color="primary"
            href={addFundModalHref}
            onClick={handleClickAddFunds}
            size="small"
            sx={{ width: 'fit-content' }}
            variant="contained"
          >
            Add funds
          </Button>
        ) : (
          <Heading
            family="secondary"
            size="2xl"
            weight="bold"
          >
            {availableBalance}
          </Heading>
        )}
      </Stack>
      <AccountDetailButton accountDetails={accountDetails} />
    </SectionWrapper>
  );
};

Balance.propTypes = {
  availableBalance: PropTypes.string.isRequired,
  accountDetails: PropTypes.shape({
    accountNumber: PropTypes.string.isRequired,
    routingNumber: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    firstAddressLine: PropTypes.string.isRequired,
    secondAddressLine: PropTypes.string.isRequired
  }).isRequired,
  addFundModalHref: PropTypes.string
};

export default Balance;
